import { render, staticRenderFns } from "./StayTunedPage.vue?vue&type=template&id=5094c482"
import script from "./StayTunedPage.vue?vue&type=script&lang=js"
export * from "./StayTunedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports